import { SliceZone } from '@prismicio/react';
import Head from 'next/head';
import { useRef } from 'react';
import { DocumentHead } from 'remote-com-shared/components/DocumentHead';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import smoothscroll from 'smoothscroll-polyfill';

import { HeroSlice } from './HeroSlice';
import { LogosSlice } from './LogosSlice';
import { OverviewSlice } from './OverviewSlice';
import { SpecialOfferSlice } from './SpecialOfferSlice';

import { FooterOnlyLayout } from '@/layouts/FooterOnly';
import { AwardsSlice } from '@/src/views/G2LeaderPage/AwardsSlice';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}

export const components = {
  hero_section: HeroSlice,
  overview_section: OverviewSlice,
  g2_awards: AwardsSlice,
  partners_logos_section: LogosSlice,
  special_offer: SpecialOfferSlice,
};

export function GlobalRecruitingEmployment(document) {
  const { body } = document;
  const applyFormRef = useRef();

  return (
    <>
      <DocumentHead document={document} />
      <Head>
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-remote-sans.css')} />
        <link rel="stylesheet" href={staticAssetUrl('/fonts/import-bossa.css')} />
      </Head>
      <SliceZone slices={body} components={components} context={{ applyFormRef }} />
    </>
  );
}
GlobalRecruitingEmployment.Layout = FooterOnlyLayout;
